// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/marine-law-applicable-to-seaplanes.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/marine-law-applicable-to-seaplanes/marine-law-applicable-to-seaplanes.js';
import g1 from '../lessons/air-law/marine-law-applicable-to-seaplanes/seaplane-marine-rules.js';

mount([g0, g1]);
